import { render, staticRenderFns } from "./shenqingkaipiao.vue?vue&type=template&id=4c921532&scoped=true&"
import script from "./shenqingkaipiao.vue?vue&type=script&lang=js&"
export * from "./shenqingkaipiao.vue?vue&type=script&lang=js&"
import style0 from "./shenqingkaipiao.vue?vue&type=style&index=0&id=4c921532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c921532",
  null
  
)

export default component.exports